import { createAsyncThunk } from "@reduxjs/toolkit";

import repo from "@/lib/repository";
import { EditSpecialistDto, NewSpecialistDto, SpecialistDto } from "@/lib/types";
import { validateServerError } from "@/lib/utils";
import { RootState } from '../store'
import { specialistsSelectedSelector } from '../selectors/specialists-selectors'

export const getSpecialists = createAsyncThunk("specialists/get/list", async (_, { rejectWithValue }) => {
  try {
    const response = await repo
      .get<SpecialistDto[]>("/specialists/list", { headers: { "content-type": "application/json" } });
    return response.data;
  }
  catch (error: any) {
    return rejectWithValue(validateServerError(error));
  }
});

export const getSpecialist = createAsyncThunk<SpecialistDto, string>("specialists/get/one", async (userId, { rejectWithValue }) => {
  try {
    const response = await repo.get<SpecialistDto>(`/specialists/list/${userId}`);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(validateServerError(error));
  }
});

export const addSpecialist = createAsyncThunk<SpecialistDto, NewSpecialistDto>("specialists/add/one", async (form, { rejectWithValue }) => {
  const data = new FormData();
  Object.keys(form).forEach(key => data.append(key, (form as any)[key]));
  try {
    const response = await repo.post<SpecialistDto>(`/specialists`, data, { headers: { "content-type": "multipart/form-data" } });
    return response.data;
  } catch (error: any) {
    return rejectWithValue(validateServerError(error));
  }
});

export const updateSpecialist = createAsyncThunk<SpecialistDto, {form: EditSpecialistDto, userId: string}>("specialists/update/one", async ({ form, userId }, { rejectWithValue, getState }) => {
  const _form: any = { ...form };
  if (typeof _form.photo === "string") {
    delete _form.photo;
  }
  const state = getState() as RootState
  const selectedSpecialist = specialistsSelectedSelector(state)
  // FIXME: remove nested structure in store
  const prevForm = {
    ...(selectedSpecialist ?? {}),
    ...(selectedSpecialist?.profile ?? {}),
  }
  const data = new FormData();
  Object.keys(_form).forEach(key => {
    // @ts-ignore
    if(prevForm[key] !== _form[key]) {
      // @ts-ignore
      data.append(key, _form[key])
    }
  });
  
  try {
    const response = await repo.patch<SpecialistDto>(`/specialists/list/${userId}`, data, { headers: { "content-type": "multipart/form-data" } });
    return response.data;
  }
  catch (error: any) {
    return rejectWithValue(validateServerError(error));
  }
});

export const deleteSpecialist = createAsyncThunk<null, string>("specialists/delete/one", async (userId, { rejectWithValue }) => {
  try {
    const response = await repo.delete<null>(`/specialists/${userId}`);
    
    return response.data;
  }
  catch (error: any) {
    return rejectWithValue(validateServerError(error));
  }
});
